import React from 'react';
import { BottomNavigation, BottomNavigationAction, Paper } from '@mui/material';
import {
  Home as HomeIcon,
  CalendarMonth as CalendarIcon,
  Map as MapIcon,
  Person as PersonIcon,
} from '@mui/icons-material';

const AndroidBottomNav = ({ activeTab, onTabChange }) => {
  return (
    <Paper 
      sx={{ 
        position: 'fixed', 
        bottom: 0, 
        left: 0, 
        right: 0,
        zIndex: 1000,
        borderTop: '1px solid rgba(0, 0, 0, 0.12)'
      }} 
      elevation={3}
    >
      <BottomNavigation
        value={activeTab}
        onChange={(event, newValue) => onTabChange(newValue)}
        showLabels
      >
        <BottomNavigationAction 
          label="Home" 
          icon={<HomeIcon />} 
        />
        <BottomNavigationAction 
          label="Calendar" 
          icon={<CalendarIcon />} 
        />
        <BottomNavigationAction 
          label="Map" 
          icon={<MapIcon />} 
        />
        <BottomNavigationAction 
          label="Profile" 
          icon={<PersonIcon />} 
        />
      </BottomNavigation>
    </Paper>
  );
};

export default AndroidBottomNav; 